module.exports = __webpack_public_path__ + "img/come.a22aa361.jpg";